import axios from 'axios'
import { setupAuthInterceptor } from '@/lib/authInterceptor'

export const ENGLISH_CONTENT_API_BASE_URL =
  import.meta.env.VITE_ENGLISH_CONTENT_API_BASE_URL || 'https://english-content-api.hocnhe.com'

export const contentAdminAxios = axios.create({
  baseURL: `${ENGLISH_CONTENT_API_BASE_URL}/v1/admin`,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
})

setupAuthInterceptor(contentAdminAxios)

export interface ApiEnvelope<T> {
  success: boolean
  code: number
  messageCode: string
  message: string
  data?: T
  pagination?: { page: number; size: number; total: number }
}

export function requireData<T>(envelope: ApiEnvelope<T>, fallback: string): T {
  if (envelope.success && envelope.data !== undefined) return envelope.data
  throw new Error((typeof envelope.data === 'string' ? envelope.data : envelope.message) || fallback)
}

export function requireSuccess(envelope: ApiEnvelope<unknown>, fallback: string): void {
  if (!envelope.success) throw new Error(envelope.message || fallback)
}
